"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatJst = void 0;
const JST_OFFSET_MS = 9 * 60 * 60 * 1000;
const pad = (n) => String(n).padStart(2, '0');
// JST has no DST, so a fixed +9h offset (rather than a locale/timezone API)
// is exact for every timestamp this admin UI ever displays.
const formatJst = (input) => {
    const date = typeof input === 'string' ? new Date(input) : input;
    const jst = new Date(date.getTime() + JST_OFFSET_MS);
    const y = jst.getUTCFullYear();
    const m = pad(jst.getUTCMonth() + 1);
    const d = pad(jst.getUTCDate());
    const h = pad(jst.getUTCHours());
    const min = pad(jst.getUTCMinutes());
    const s = pad(jst.getUTCSeconds());
    return `${y}/${m}/${d} ${h}:${min}:${s}`;
};
exports.formatJst = formatJst;
